/** Compare visit dates descending (most recent first). Empty dates sort last. */
export const compareVisitDatesDesc = (a: string, b: string): number => {
  if (a === b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a < b ? 1 : -1;
};

/** Returns the more recent of two YYYY-MM-DD visit dates. */
export const pickMostRecentVisitDate = (a: string, b: string): string => {
  if (!a) return b;
  if (!b) return a;
  return compareVisitDatesDesc(a, b) <= 0 ? a : b;
};

/** Deduplication key: NPI when present, otherwise name + address. */
export const doctorDedupKey = (
  npi: string,
  name: string,
  address: string,
): string => {
  if (npi) return `npi:${npi}`;
  return `name:${name}|addr:${address}`;
};
